import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

import withIframeStyle from '../../containers/WithIframeStyle';
import { getRestaurantMenuModalBodyStyle, getRestaurantMenuModalStyle } from '../../utils/iframe-style-helper';

const RestaurantMenuModal = props => {
  const { className, iframeStyle, iframeStyleKey, isOpen, toggle, title } = props;
  const modalStyle = (iframeStyle && iframeStyle[iframeStyleKey]) || null;
  const modalBodyStyle = (iframeStyle && iframeStyle.modalBody) || null;
  return <Modal
    className={className}
    isOpen={isOpen}
    style={modalStyle}>
    <ModalHeader toggle={toggle}>{title}</ModalHeader>
    <ModalBody style={modalBodyStyle}>{props.children}</ModalBody>
  </Modal>
};

const calculateStyle = pageInfo => {
  const modalStyle = getRestaurantMenuModalStyle(pageInfo);
  return {
    cartModal: modalStyle,
    checkoutModal: modalStyle,
    modalBody: getRestaurantMenuModalBodyStyle(pageInfo),
  };
};
export default withIframeStyle(RestaurantMenuModal, calculateStyle, { repaintOnInit: true });
